module.exports = __webpack_public_path__ + "static/media/navigation_flow.a6981d59.jpg";